import React, { useContext } from 'react'
import DoughnutChart from '../../../../components/DoughnutChart'
import { AppContext } from '../../../../contexts/AppContext'

interface Props {
	data: number[]
	centerText?: string
	centerSubText?: string
}

const ProductionDoughnut: React.FC<Props> = ({ data, centerText, centerSubText }) => {
	const { isDarkMode } = useContext(AppContext)
	const backgroundColors = isDarkMode ? ['#3cb49f', '#063a3e'] : ['#52ae32', '#cae3cc']

	return (
		<div className='relative'>
			<DoughnutChart data={data} backgroundColors={backgroundColors} darkModeEnabled={isDarkMode} />
			{centerText && (
				<div className='absolute inset-0 flex flex-col items-center justify-center'>
					<div className='text-center'>
						<p className='text-xl font-semibold dark:text-white'>{centerText}</p>
						{centerSubText && <p className='text-sm dark:text-text-grey-100'>{centerSubText}</p>}
					</div>
				</div>
			)}
		</div>
	)
}

export default ProductionDoughnut
